/* eslint-disable import/prefer-default-export */
export function getDevice () {
  if (navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i)) {
    return 'Mobile'
  }

  if (navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform)) {
    return 'Mobile'
  }
  return 'Desktop'
}
